function rejectWithMessage(error) {
    return Promise.reject(error.message);
}
const engine = (key, replacer, reviver)=>({
        load () {
            return new Promise((resolve)=>{
                const jsonState = sessionStorage.getItem(key);
                resolve(JSON.parse(jsonState, reviver) || {});
            }).catch(rejectWithMessage);
        },
        save (state) {
            return new Promise((resolve)=>{
                const jsonState = JSON.stringify(state, replacer);
                sessionStorage.setItem(key, jsonState);
                resolve();
            }).catch(rejectWithMessage);
        },
        clear () {
            sessionStorage.removeItem(key);
        }
    });
export default engine;
export function replacer(key, value) {
    const originalObject = this[key];
    if (originalObject instanceof Map) {
        return {
            dataType: 'Map',
            value: Array.from(originalObject.entries())
        };
    } else {
        return value;
    }
}
export function reviver(key, value) {
    if (key === '') {
        return value;
    }
    if (typeof value === 'object' && value !== null) {
        if (value.dataType === 'Map') {
            return new Map(value.value);
        }
    }
    return value;
}
